import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import DownloadIcon from '../../../Assets/Images/svgs/download.svg';

const DownloadButtons = ({ handleDownload }) => (
	<div
		style={{
			alignSelf: 'flex-start',
			display: 'flex',
			alignItems: 'center',
			marginLeft: '20px'
		}}
	>
		<span style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }}>CSV</span>
		<Box
			component={'img'}
			src={DownloadIcon}
			alt='Download Icon'
			style={{ cursor: 'pointer', width: '50px', height: '40px' }}
			onClick={() => handleDownload('csv')}
		/>
		<span
			style={{
				color: 'white',
				fontWeight: 'bold',
				marginLeft: '10px',
				marginRight: '10px'
			}}
		>
        XLSX
		</span>
		<Box
			component={'img'}
			src={DownloadIcon}
			alt='Download Icon'
			style={{
				cursor: 'pointer',
				width: '50px',
				height: '40px',
				marginRight: '10px'
			}}
			onClick={() => handleDownload('xlsx')}
		/>
	</div>
);

DownloadButtons.propTypes = {
	handleDownload: PropTypes.func.isRequired
};

export default DownloadButtons;
